import SectionLayout from "../components/SectionLayout";
import SectionHeader from "../components/SectionHeader";
import ContactItem from "../components/ContactItem";

import {
  FaFacebookF,
  FaTwitter,
  FaEnvelope,
  FaInstagram,
  FaPhone,
} from "react-icons/fa";

export default function Contact() {
  return (
    <SectionLayout id="contact" index={4}>
      <SectionHeader>Be In Touch</SectionHeader>
      <div className=" w-full px-8 sm:p-0 sm:w-fit">
        <ContactItem
          text="ahmedazad10@outlook.com"
          icon={<FaEnvelope className=" w-1/2 h-1/2" />}
          link={"mailto:ahmedazad10@outlook.com"}
        />
        <ContactItem
          text="Ahmed Azad"
          icon={<FaFacebookF className=" w-1/2 h-1/2" />}
          link={"https://www.facebook.com/ahmed.azad.940436"}
        />
        <ContactItem
          text="@ahmedazd0"
          icon={<FaTwitter className=" w-1/2 h-1/2" />}
          link={"https://twitter.com/ahmedazad0"}
        />
        <ContactItem
          text="@AhmedAzadIB"
          icon={<FaInstagram className=" w-1/2 h-1/2" />}
          link={"https://instagram.com/ahmedazadib"}
        />
        <ContactItem
          text="Call Ahmed"
          icon={<FaPhone className=" w-1/2 h-1/2" />}
          link={"tel:+9647515221260"}
        />
      </div>
    </SectionLayout>
  );
}
